/* global POLYFILL_PATH, SVG_PATH */
const config = window.cigna || {};

config.polyfillPath = (typeof POLYFILL_PATH === 'undefined') ? '' : POLYFILL_PATH;
config.svgPath = (typeof SVG_PATH === 'undefined') ? '' : SVG_PATH;

export const updateConfig = cfg => Object.assign(config, cfg);

export default config;



// WEBPACK FOOTER //
// ./node_modules/cigna-frontend/js/util/config.js